<div
    class="add--header"
    data-testid="t-contacts-div-1752672977568-3"
>
    <div
        class="col"
        data-testid="t-contacts-div-1752672977568-1"
    >
        <span
            class="h5"
            data-testid="t-contacts-span-1752672977568-1"
            >{{ 'mws.contacts' | i18n }}</span
        >
    </div>

    @if (updateable() && coreService.checkAbility('execute', 'supplier.new')) {
        <div
            class="col-auto text-end"
            data-testid="t-contacts-div-1752672977568-2"
        >
            <a
                (click)="showContact(undefined)"
                class="btn btn-sm action--btn btn-primary"
                placement="left"
                [attr.aria-label]="'mws.add' | i18n"
                data-testid="t-contacts-a-1752672977568-1"
            >
                <i
                    class="oc-plus"
                    data-testid="t-contacts-i-1752672977568-1"
                ></i> </a
            >&nbsp;
        </div>
    }
</div>

<!-- SIEHE: https://stackblitz.com/angular/nqdqmkykbvg?file=src%2Fapp%2Ftable-expandable-rows-example.html -->
<!-- SIEHE: https://stackblitz.com/angular/nqdqmkykbvg?file=src%2Fapp%2Ftable-expandable-rows-example.html -->
<!-- SIEHE: https://stackblitz.com/angular/nqdqmkykbvg?file=src%2Fapp%2Ftable-expandable-rows-example.html s-->
<div
    class="table-oc-responsive table-responsive table-centered table-scrollable"
    data-testid="t-contacts-div-1752672977568-35"
>
    <table
        cdk-table
        [dataSource]="contacts"
        multiTemplateDataRows
        id="contactTable"
        class="table overflow-hidden first-cell-auto-width"
        data-testid="t-contacts-table-1752672977568-2"
    >
        <!--        displayedColumnsContact = ['isFavorite', 'isEmergency', 'genderSdescr', 'lastName', 'firstName', 'department', 'edit', 'new', 'delete'];-->

        <ng-container cdkColumnDef="contactIcons">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-contacts-th-1752672977568-1"
            ></th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-contacts-td-1752672977568-1"
            >
                @if (element.isFavorite === true || element.isEmergency === true) {
                    <span
                        class="cdk-cell cdk-column-contactIcons ng-tns-c291-0 ng-star-inserted"
                        data-testid="t-contacts-span-1752672977568-2"
                    >
                        @if (element.isFavorite === true) {
                            <i
                                class="d-inline-block oc-heart-filled fs-20 text-primary"
                                [ngbTooltip]="'mws.favorite' | i18n"
                                data-testid="t-contacts-i-1752672977568-2"
                            ></i>
                        }
                        @if (element.isEmergency === true) {
                            <i
                                class="d-inline-block oc-general-danger fs-20 text-primary"
                                [ngbTooltip]="'mws.emergency' | i18n"
                                data-testid="t-contacts-i-1752672977568-3"
                            ></i>
                        }
                    </span>
                }
            </td>
        </ng-container>

        <!--        <ng-container cdkColumnDef="isEmergency">-->
        <!--            <th cdk-header-cell *cdkHeaderCellDef></th>-->
        <!--            <td cdk-cell *cdkCellDef="let elementRef">-->
        <!--                -->
        <!--            </td>-->
        <!--        </ng-container>-->

        <!--        *ngIf="coreService.checkAbility('read', privilegeContext+'contact.gender')"-->
        <ng-container cdkColumnDef="genderSdescr">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-contacts-th-1752672977568-2"
            ></th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-contacts-td-1752672977568-2"
            >
                @if (coreService.checkAbility('read', 'suppliercontact.genderid')) {
                    <span data-testid="t-contacts-span-1752672977568-3">{{ element.genderSdescr }}</span>
                }
            </td>
        </ng-container>

        <ng-container cdkColumnDef="lastName">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-contacts-th-1752672977568-3"
            >
                {{ 'mws.name' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-contacts-td-1752672977568-3"
            >
                @if (coreService.checkAbility('read', 'suppliercontact.lastname')) {
                    <span data-testid="t-contacts-span-1752672977568-4">{{ element.lastName }}</span>
                }
            </td>
        </ng-container>

        <ng-container cdkColumnDef="firstName">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-contacts-th-1752672977568-4"
            >
                {{ 'mws.firstname' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-contacts-td-1752672977568-4"
            >
                @if (coreService.checkAbility('read', 'suppliercontact.firstname')) {
                    <span data-testid="t-contacts-span-1752672977568-5">{{ element.firstName }}</span>
                }
            </td>
        </ng-container>

        <ng-container cdkColumnDef="department">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-contacts-th-1752672977568-5"
            >
                {{ 'mws.department' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-contacts-td-1752672977568-5"
            >
                @if (coreService.checkAbility('read', 'suppliercontact.department')) {
                    <span data-testid="t-contacts-span-1752672977568-6">{{ element.department }}</span>
                }
            </td>
        </ng-container>

        <ng-container cdkColumnDef="buttons">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-contacts-th-1752672977568-6"
            ></th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                align="right"
                data-testid="t-contacts-td-1752672977568-6"
            >
                <a
                    class="btn btn-sm action--btn btn-primary"
                    [attr.aria-label]="'mws.show' | i18n"
                    data-testid="t-contacts-a-1752672977568-2"
                >
                    <i
                        class="oc-eye"
                        data-testid="t-contacts-i-1752672977568-4"
                    ></i
                ></a>
                <!--                ('read' | ablePure: privilegeContext+'update' | async)-->
                @if (coreService.checkAbility('execute', 'suppliercontact.edit') && updateable()) {
                    <a
                        class="btn btn-sm action--btn btn-primary"
                        [attr.aria-label]="'mws.edit' | i18n"
                        (click)="showContact(element); $event.stopPropagation()"
                        data-testid="t-contacts-a-1752672977568-3"
                        ><i
                            class="oc-general-edit"
                            data-testid="t-contacts-i-1752672977568-5"
                        ></i
                    ></a>
                }

                <!--                <div *ngIf="column==='new' && elementRef[column]" style="float: right">-->
                <!--                    <button (click)="showCommunicationModal(elementRef['desc'])" type="button" class="btn btn-sm btn-primary">neuer Kommunikationsweg</button>-->
                <!--                </div>-->
                @if (coreService.checkAbility('execute', 'suppliercontact.delete') && updateable()) {
                    <a
                        class="btn btn-sm btn-danger action--btn"
                        [attr.aria-label]="'button.delete' | i18n"
                        (click)="deleteContact(element); $event.stopPropagation()"
                        data-testid="t-contacts-a-1752672977568-4"
                        ><i
                            class="oc-trash-can"
                            data-testid="t-contacts-i-1752672977568-6"
                        ></i
                    ></a>
                }

                @if (coreService.checkAbility('execute', 'supplier.contact.detail.new') && updateable()) {
                    <a
                        class="btn btn-sm action--btn btn-primary"
                        [attr.aria-label]="'mws.addresstype' | i18n"
                        (click)="showCommunication(element['id'], undefined); $event.stopPropagation()"
                        data-testid="t-contacts-a-1752672977568-5"
                        ><i
                            class="oc-plus"
                            data-testid="t-contacts-i-1752672977568-7"
                        ></i
                    ></a>
                }
            </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container cdkColumnDef="expandedDetail">
            <td
                cdk-cell
                *cdkCellDef="let element"
                [attr.colspan]="displayedColumnsContact.length"
                data-testid="t-contacts-td-1752672977568-10"
            >
                <div
                    style="overflow: hidden"
                    class="nested-oc-table-element"
                    [@detailExpand]="element == expandedElementSupplierContactDetail ? 'expanded' : 'collapsed'"
                    data-testid="t-contacts-div-1752672977568-7"
                >
                    <div
                        class="nested-oc-table-content"
                        data-testid="t-contacts-div-1752672977568-6"
                    >
                        <div
                            class="separator"
                            data-testid="t-contacts-div-1752672977568-4"
                        >
                            {{ 'mws.communicationchannels' | i18n }}
                        </div>
                        <!-- START CONTENT -->
                        <div
                            class="table-responsive table-centered table-oc-responsive"
                            data-testid="t-contacts-div-1752672977568-5"
                        >
                            <table
                                class="table first-cell-auto-width m-0"
                                data-testid="t-contacts-table-1752672977568-1"
                            >
                                <tbody data-testid="t-contacts-tbody-1752672977568-1">
                                    @for (item of element.contactDetails; track item) {
                                        <tr data-testid="t-contacts-tr-1752672977568-1">
                                            <td data-testid="t-contacts-td-1752672977568-7">
                                                @if (coreService.checkAbility('read', 'supplier.contact.detail.contacttypeid')) {
                                                    <i
                                                        [ngClass]="item.contactTypeStyleClass"
                                                        ngbTooltip="{{ item.contactTypeDescr }}"
                                                        data-testid="t-contacts-i-1752672977568-8"
                                                    ></i>
                                                }
                                            </td>
                                            <td data-testid="t-contacts-td-1752672977568-8">
                                                @if (coreService.checkAbility('read', 'supplier.contact.detail.contactinfo')) {
                                                    <span data-testid="t-contacts-span-1752672977568-7">{{ item.contactInfo }}</span>
                                                }
                                            </td>
                                            <td
                                                class="text-nowrap align-middle text-end"
                                                data-testid="t-contacts-td-1752672977568-9"
                                            >
                                                @if (coreService.checkAbility('execute', 'supplier.contact.detail.edit') && updateable()) {
                                                    <a
                                                        class="btn btn-sm action--btn btn-primary"
                                                        [attr.aria-label]="'mws.edit' | i18n"
                                                        (click)="showCommunication(element.id, item)"
                                                        data-testid="t-contacts-a-1752672977568-6"
                                                        ><i
                                                            class="oc-general-edit"
                                                            data-testid="t-contacts-i-1752672977568-9"
                                                        ></i
                                                    ></a>
                                                }
                                                @if (coreService.checkAbility('execute', 'supplier.contact.detail.delete') && updateable()) {
                                                    <a
                                                        class="btn btn-sm btn-danger action--btn"
                                                        [attr.aria-label]="'button.delete' | i18n"
                                                        href="javascript:void(0)"
                                                        (click)="deleteContactDetail(element, item)"
                                                        data-testid="t-contacts-a-1752672977568-7"
                                                        ><i
                                                            class="oc-trash-can"
                                                            data-testid="t-contacts-i-1752672977568-10"
                                                        ></i
                                                    ></a>
                                                }
                                                <a
                                                    class="btn btn-sm btn-success action--btn"
                                                    [attr.aria-label]="'button.add' | i18n"
                                                    href="javascript:void(0)"
                                                    (click)="chooseContactDetail(element, item)"
                                                    data-testid="t-contacts-a-1752672977568-8"
                                                    ><i
                                                        class="oc-general-check"
                                                        data-testid="t-contacts-i-1752672977568-11"
                                                    ></i
                                                ></a>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <!-- END CONTENT -->
                    </div>
                </div>
            </td>
        </ng-container>

        <tr
            cdk-header-row
            *cdkHeaderRowDef="displayedColumnsContact"
            data-testid="t-contacts-tr-1752672977568-2"
        ></tr>
        <tr
            cdk-row
            *cdkRowDef="let element; columns: displayedColumnsContact; let i = dataIndex"
            class="table-oc-row is-clickable"
            [ngClass]="{ selected: expandedElementSupplierContactDetail === element }"
            [class.example-expanded-row]="expandedElementSupplierContactDetail === element"
            (click)="expandedElementSupplierContactDetail = expandedElementSupplierContactDetail === element ? null : element"
            data-testid="t-contacts-tr-1752672977568-3"
        ></tr>
        <tr
            cdk-row
            *cdkRowDef="let row; columns: ['expandedDetail']"
            class="table-oc-expanded-row"
            data-testid="t-contacts-tr-1752672977568-4"
        ></tr>
    </table>

    <!-- Modal CONTACT -->
    <ng-template
        #contactModal
        let-c="close"
        let-d="dismiss"
    >
        <form
            [formGroup]="supplierContactForm"
            class="customer-form"
            novalidate
            data-testid="t-contacts-form-1752672977568-1"
        >
            <div
                class="modal-header"
                data-testid="t-contacts-div-1752672977568-8"
            >
                <button
                    type="button"
                    [attr.aria-label]="'button.close' | i18n"
                    id="contact-cancel"
                    class="btn btn-close"
                    (click)="d('Close click')"
                    data-testid="t-contacts-button-1752672977568-1"
                >
                    <i
                        class="oc-general-cancel"
                        data-testid="t-contacts-i-1752672977568-12"
                    ></i>
                </button>
                <span
                    class="h5 modal-title"
                    data-testid="t-contacts-span-1752672977568-8"
                    >{{ contactModalHeader | i18n }}</span
                >
            </div>

            <div
                class="modal-body"
                data-testid="t-contacts-div-1752672977568-20"
            >
                @if (coreService.checkAbility('read', 'suppliercontact.genderid')) {
                    <div
                        class="form-group"
                        data-testid="t-contacts-div-1752672977568-10"
                    >
                        <div
                            class="select-wrapper"
                            data-testid="t-contacts-div-1752672977568-9"
                        >
                            <oc-label
                                [forElement]="'genderId'"
                                [schema]="'supplierContact'"
                                [propertyName]="'genderId'"
                                [value]="'mws.gender' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-contacts-oc-label-1752672977568-1"
                            ></oc-label>
                            <select
                                formControlName="genderId"
                                id="genderId"
                                class="form-select"
                                data-testid="t-contacts-select-1752672977568-1"
                            >
                                <option
                                    [ngValue]="null"
                                    data-testid="t-contacts-option-1752672977568-1"
                                >
                                    {{ 'mws.pleasechoose' | i18n }}
                                </option>
                                @for (g of environmentService.genderList; track g) {
                                    <option
                                        [ngValue]="g.id"
                                        data-testid="t-contacts-option-1752672977568-2"
                                    >
                                        {{ g.sdescr ? g.sdescr : g.descr }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                }

                @if (coreService.checkAbility('read', 'suppliercontact.lastname')) {
                    <div
                        class="form-group"
                        data-testid="t-contacts-div-1752672977568-12"
                    >
                        <div
                            class="select-wrapper"
                            data-testid="t-contacts-div-1752672977568-11"
                        >
                            <oc-label
                                [forElement]="'lastName'"
                                [schema]="'supplierContact'"
                                [propertyName]="'lastName'"
                                [value]="'mws.surname' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-contacts-oc-label-1752672977568-2"
                            ></oc-label>
                            <input
                                type="text"
                                class="form-control"
                                id="lastName"
                                formControlName="lastName"
                                placeholder="Name"
                                data-testid="t-contacts-input-1752672977568-1"
                            />
                        </div>
                        <oc-validator-error
                            [control]="suppliercontactf.lastName"
                            [propertyName]="'lastName'"
                            data-testid="t-contacts-oc-validator-error-1752672977568-1"
                        ></oc-validator-error>
                    </div>
                }

                @if (coreService.checkAbility('read', 'suppliercontact.firstname')) {
                    <div
                        class="form-group"
                        data-testid="t-contacts-div-1752672977568-14"
                    >
                        <div
                            class="select-wrapper"
                            data-testid="t-contacts-div-1752672977568-13"
                        >
                            <oc-label
                                [forElement]="'firstName'"
                                [schema]="'supplierContact'"
                                [propertyName]="'firstName'"
                                [value]="'mws.firstname' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-contacts-oc-label-1752672977568-3"
                            ></oc-label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="firstName"
                                placeholder="{{ 'mws.firstname' | i18n }}"
                                data-testid="t-contacts-input-1752672977568-2"
                            />
                        </div>
                        <oc-validator-error
                            [control]="suppliercontactf.firstName"
                            [propertyName]="'firstName'"
                            data-testid="t-contacts-oc-validator-error-1752672977568-2"
                        ></oc-validator-error>
                    </div>
                }

                @if (coreService.checkAbility('read', 'suppliercontact.department')) {
                    <div
                        class="form-group"
                        data-testid="t-contacts-div-1752672977568-16"
                    >
                        <div
                            class="select-wrapper"
                            data-testid="t-contacts-div-1752672977568-15"
                        >
                            <oc-label
                                [forElement]="'department'"
                                [schema]="'supplierContact'"
                                [propertyName]="'department'"
                                [value]="'mws.department' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-contacts-oc-label-1752672977568-4"
                            ></oc-label>
                            <input
                                type="text"
                                class="form-control"
                                id="department"
                                formControlName="department"
                                placeholder="{{ 'mws.department' | i18n }}"
                                data-testid="t-contacts-input-1752672977568-3"
                            />
                        </div>
                        <oc-validator-error
                            [control]="suppliercontactf.department"
                            [propertyName]="'department'"
                            data-testid="t-contacts-oc-validator-error-1752672977568-3"
                        ></oc-validator-error>
                    </div>
                }

                <div
                    class="form-group"
                    data-testid="t-contacts-div-1752672977568-19"
                >
                    @if (coreService.checkAbility('read', 'suppliercontact.favorite')) {
                        <div
                            class="form-check d-inline-flex me-3"
                            data-testid="t-contacts-div-1752672977568-17"
                        >
                            <input
                                class="form-check-input"
                                type="checkbox"
                                formControlName="isFavorite"
                                data-testid="t-contacts-input-1752672977568-4"
                            />
                            <label
                                class="form-check-label"
                                data-testid="t-contacts-label-1752672977568-1"
                                >{{ 'mws.favorite' | i18n }}</label
                            >
                        </div>
                    }
                    @if (coreService.checkAbility('read', 'suppliercontact.emergency')) {
                        <div
                            class="form-check d-inline-flex"
                            data-testid="t-contacts-div-1752672977568-18"
                        >
                            <input
                                class="form-check-input"
                                type="checkbox"
                                formControlName="isEmergency"
                                data-testid="t-contacts-input-1752672977568-5"
                            />
                            <label
                                class="form-check-label"
                                data-testid="t-contacts-label-1752672977568-2"
                                >{{ 'mws.emergency' | i18n }}</label
                            >
                        </div>
                    }
                </div>
            </div>
            <div
                class="modal-footer"
                data-testid="t-contacts-div-1752672977568-22"
            >
                <div
                    class="button-wrapper"
                    data-testid="t-contacts-div-1752672977568-21"
                >
                    @if (!supplierContactForm.get('id').value) {
                        <button
                            type="button"
                            [attr.aria-label]="'button.saveandnew' | i18n"
                            id="contact-success-new"
                            class="btn btn-success me-auto"
                            [disabled]="!supplierContactForm.get('changed').touched"
                            (click)="saveContact(false)"
                            data-testid="t-contacts-button-1752672977568-2"
                        >
                            <i
                                class="oc-save-and-new"
                                data-testid="t-contacts-i-1752672977568-13"
                            ></i>
                        </button>
                    }

                    <button
                        [attr.aria-label]="'button.check' | i18n"
                        type="button"
                        id="contact-success"
                        class="btn btn-success"
                        [disabled]="!supplierContactForm.get('changed').touched"
                        (click)="saveContact(true)"
                        data-testid="t-contacts-button-1752672977568-3"
                    >
                        <i
                            class="oc-general-check"
                            data-testid="t-contacts-i-1752672977568-14"
                        ></i>
                    </button>
                </div>
            </div>
        </form>
    </ng-template>
    <!-- Modal COMMUNICATION -->
    <ng-template
        #communicationModal
        let-c="close"
        let-d="dismiss"
    >
        <form
            [formGroup]="supplierContactDetailForm"
            class="customer-form"
            novalidate
            data-testid="t-contacts-form-1752672977568-2"
        >
            <div
                class="modal-header"
                data-testid="t-contacts-div-1752672977568-23"
            >
                <button
                    type="button"
                    [attr.aria-label]="'button.close' | i18n"
                    class="btn btn-close"
                    (click)="d('Close click')"
                    data-testid="t-contacts-button-1752672977568-4"
                >
                    <i
                        class="oc-general-cancel"
                        data-testid="t-contacts-i-1752672977568-15"
                    ></i>
                </button>
                <span
                    class="h5 modal-title"
                    data-testid="t-contacts-span-1752672977568-9"
                    >{{ contactDetailModalHeader | i18n }}</span
                >
            </div>

            <div
                class="modal-body"
                data-testid="t-contacts-div-1752672977568-28"
            >
                @if (coreService.checkAbility('read', 'supplier.contact.detail.contacttypeid')) {
                    <div
                        class="form-group"
                        data-testid="t-contacts-div-1752672977568-25"
                    >
                        <div
                            class="select-wrapper"
                            data-testid="t-contacts-div-1752672977568-24"
                        >
                            <oc-label
                                [forElement]="'contactTypeId'"
                                [schema]="'supplierContactDetail'"
                                [propertyName]="'contactTypeId'"
                                [value]="'mws.communicationtype' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-contacts-oc-label-1752672977568-5"
                            ></oc-label>
                            <select
                                formControlName="contactTypeId"
                                id="contactTypeId"
                                class="form-select"
                                data-testid="t-contacts-select-1752672977568-2"
                            >
                                @for (ct of environmentService.contactTypeList; track ct) {
                                    <option
                                        [ngValue]="ct.id"
                                        data-testid="t-contacts-option-1752672977568-3"
                                    >
                                        {{ ct.descr }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                }

                @if (coreService.checkAbility('read', 'supplier.contact.detail.contactinfo')) {
                    <div
                        class="form-group"
                        data-testid="t-contacts-div-1752672977568-27"
                    >
                        <div
                            class="select-wrapper"
                            data-testid="t-contacts-div-1752672977568-26"
                        >
                            <oc-label
                                [forElement]="'contactInfo'"
                                [schema]="'supplierContactDetail'"
                                [propertyName]="'contactInfo'"
                                [value]="'mws.entry' | i18n"
                                [classes]="'form-label'"
                                data-testid="t-contacts-oc-label-1752672977568-6"
                            ></oc-label>
                            <input
                                type="text"
                                class="form-control"
                                id="contactInfo"
                                formControlName="contactInfo"
                                placeholder=""
                                data-testid="t-contacts-input-1752672977568-6"
                            />
                            <oc-validator-error
                                [control]="suppliercontactdetailf.contactInfo"
                                [propertyName]="'contactInfo'"
                                [inputElementId]="'contactInfo'"
                                data-testid="t-contacts-oc-validator-error-1752672977568-4"
                            ></oc-validator-error>
                        </div>
                    </div>
                }
            </div>
            <div
                class="modal-footer"
                data-testid="t-contacts-div-1752672977568-30"
            >
                <div
                    class="button-wrapper"
                    data-testid="t-contacts-div-1752672977568-29"
                >
                    @if (!supplierContactDetailForm.get('id').value) {
                        <button
                            type="button"
                            [attr.aria-label]="'button.saveandnew' | i18n"
                            id="communication-success-new"
                            class="btn btn-success me-auto"
                            [disabled]="!supplierContactDetailForm.get('changed').touched"
                            (click)="saveContactDetail(false)"
                            data-testid="t-contacts-button-1752672977568-5"
                        >
                            <i
                                class="oc-save-and-new"
                                data-testid="t-contacts-i-1752672977568-16"
                            ></i>
                        </button>
                    }
                    <button
                        [attr.aria-label]="'button.check' | i18n"
                        type="button"
                        id="communication-success"
                        class="btn btn-success"
                        [disabled]="!supplierContactDetailForm.get('changed').touched"
                        (click)="saveContactDetail(true)"
                        data-testid="t-contacts-button-1752672977568-6"
                    >
                        <i
                            class="oc-general-check"
                            data-testid="t-contacts-i-1752672977568-17"
                        ></i>
                    </button>
                </div>
            </div>
        </form>
    </ng-template>

    <!-- Modal template -->
    <ng-template
        #messageModal
        let-c="close"
        let-d="dismiss"
    >
        <div
            class="modal-header"
            data-testid="t-contacts-div-1752672977568-31"
        >
            <button
                type="button"
                id="cancel"
                [attr.aria-label]="'button.discard' | i18n"
                class="btn btn-close"
                (click)="undoTempValues(); d('Close click')"
                data-testid="t-contacts-button-1752672977568-7"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-contacts-i-1752672977568-18"
                ></i>
            </button>
            <span
                class="h5 modal-title"
                data-testid="t-contacts-span-1752672977568-10"
                >{{ modalMessageTitle | i18n }}</span
            >
        </div>

        <div
            class="modal-body"
            [innerHTML]="modalMessageBody | i18n"
            data-testid="t-contacts-div-1752672977568-32"
        ></div>

        <div
            class="modal-footer"
            data-testid="t-contacts-div-1752672977568-34"
        >
            <div
                class="button-wrapper"
                data-testid="t-contacts-div-1752672977568-33"
            >
                <button
                    type="button"
                    id="success"
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    (click)="deleteElement(); c('Close click')"
                    data-testid="t-contacts-button-1752672977568-8"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-contacts-i-1752672977568-19"
                    ></i>
                </button>
            </div>
        </div>
    </ng-template>
</div>
